import { Component, OnInit, ViewChild } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { InvoiceService } from '../../services/invoice.service';
import { ReportService } from '../../services/report.service';
import { SharedService } from '../../services/shared.service';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { MatDatepicker } from '@angular/material';
import { default as _rollupMoment, Moment } from 'moment';
import { InvoiceCacheService } from '../../services/invoice-cache.service';

import { INVOICE_REVIEW_STATUS } from '../../shared-data/invoice-review-status';
import { INVOICE_SAGE_STATUS } from '../../shared-data/invoice-sage-status';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-invoice-review',
  templateUrl: './invoice-review.component.html',
  styleUrls: ['./invoice-review.component.css'],
  providers: [    
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InvoiceReviewComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private invoiceService: InvoiceService,
    private reportService: ReportService,
    private router: Router,
    private invoiceCacheService: InvoiceCacheService,
  ) {    
  }

  ngOnInit() {
    this.showLoadingMessage = true;
    this.sharedService.reloadUserPrivileges();
    this.invoiceList = this.invoices;
    this.loadDate();
    this.showLoadingMessage = false;
    // this.updateInvoices();
  }

  @ViewChild('ApplyStatusConfirmModalClosebutton', { static: false }) closebutton;
 
  confirmAction: Function = null;
  invoiceList: any[];
  showErrorMessage: boolean;
  errorMessage: string;  
  showLoadingMessage: boolean;
  searchResident: string = '';
  billableMonthAndYear: Date;
  btnFilterSelected = 'ALL';
  patientName: string = '';
  
  deleteModalStatusId: number = 1;
  displaySuccessMessage: boolean = false;
  successMessage: string = '';

  filters = [
    { label: 'ALL', action: () => this.onFilterAll() },
    { label: 'PENDING', action: () => this.onFilterPending() },
    { label: 'FLAGGED', action: () => this.onFilterFlagged() },
    { label: 'APPROVED', action: () => this.onFilterApproved() },
    { label: 'SENT BY EMAIL', action: () => this.onFilterSentByEmail() }
  ];

  reviewStatus = INVOICE_REVIEW_STATUS;
  sageStatus = INVOICE_SAGE_STATUS;

  invoices = [];

  get deleteModalTxtObj() {
    let patientName = this.patientName;

    let deleteAllModalHeadersAndBodys = {
      1: {
        header: `Set Invoice Status to <span class="fw-bold">Flagged</span>`,
        body: `<h6>Are you sure you want to apply the status <span class="fw-bold">Flagged</span> on all invoices?</h6>`
      },
      2: {
        header: `Set Invoice Status to <span class="fw-bold">Approved</span>`,
        body: `<h6>Are you sure you want to apply the status <span class="fw-bold">Approved</span> on all invoices?</h6>`
      },
      3: {
        header: `Set Invoice Status to <span class="fw-bold">Flagged</span>`,
        body: `<h6>Are you sure you want to apply the status <span class="fw-bold">Flagged</span> on <span class="fw-bold">${patientName}</span> invoice?</h6>`
      },
      4: {
        header: `Set Invoice Status to <span class="fw-bold">Approved</span>`,
        body: `<h6>Are you sure you want to apply the status <span class="fw-bold">Approved</span> on <span class="fw-bold">${patientName}</span> invoice?</h6>`
      },
      5: {
        header: `Send Invoice to <span class="fw-bold">Sage</span>`,
        body: `<h6>Are you sure you want to send the <span class="fw-bold">${patientName}</span> invoice to sage?</h6>`
      },
      6: {
        header: `Send Invoice to <span class="fw-bold">Sage</span>`,
        body: `<h6>Are you sure you want to send <span class="fw-bold">all invoices</span> to sage?</h6>`
      }
    }
    return deleteAllModalHeadersAndBodys[this.deleteModalStatusId];
  }

  get getTotalPending(): number {
    return this.invoices.filter(i => i.invoiceReviewStatusId === 1).length;
  }

  get getTotalFlagged(): number {
    return this.invoices.filter(i => i.invoiceReviewStatusId === 2).length;
  }

  get getTotalApproved(): number {
    return this.invoices.filter(i => i.invoiceReviewStatusId === 3).length;
  }

  get enablePrint(): boolean {
    if (this.invoices.length === 0) return false;

    let invoicesLength = this.invoices.length;

    return this.getTotalApproved === invoicesLength && this.getTotalCompletedToSage === invoicesLength;
  }

  //get getTotalToSendToSage(): number {
  //  return this.invoices.filter(i => i.invoiceSageStatusId === 1).length;
  //}

  get getTotalCompletedToSage(): number {
    return this.invoices.filter(i => i.invoiceSageStatusId >= 3).length;
  }

  get statusSummary(): string {
    const total = this.invoices.length;

    const pending = this.getTotalPending;
    const flagged = this.getTotalFlagged;
    const approved = this.getTotalApproved;
    const sentToSage = this.getTotalCompletedToSage;

    return `<span class="text-secondary">FLAGGED ${flagged} OF ${total}</span>
      / <span class="text-secondary">PENDING ${pending} OF ${total}</span>
      / <span class="text-secondary">APPROVED ${approved} OF ${total}</span>
      / <span class="text-secondary">SENT TO SAGE ${sentToSage} OF ${total}</span>
      `;
  }

  get billingDateFormated(): string {
    const billingDate = moment(this.billableMonthAndYear);
    return billingDate.format('YYYY-MM-DD');
  }

  openInvoice(invoiceId) {
    this.router.navigate([]).then(result => { window.open('report/invoice/' + invoiceId + '/' + 'Invoice', '_blank'); });
  }

  onSendAllInvoicesByEmail() {
    if (!this.enablePrint) return;

    this.showLoadingMessage = true;

    const selectedInvoices = this.invoiceList.filter(item => item.selected
      && item.invoiceReviewStatusId === 3
      && item.invoiceSageStatusId >= 3
      && item.total > 0);

    const invoiceList = selectedInvoices.length > 0
      ? selectedInvoices
      : this.invoiceList.filter(item => item.invoiceReviewStatusId === 3
        && item.invoiceSageStatusId >= 3 && item.total > 0);

    let invoiceIds = invoiceList.map(item => item.id);

    this.invoiceService.sendAllInvoicesByEmail(this.sharedService.pharmacyId, this.sharedService.facilityId, invoiceIds)
      .pipe(
        timeout(6000000)
      )
      .subscribe(data => {
        if (!data.success) {
          this.showLoadingMessage = false;
          this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
          return;
        }
        this.showSuccessMessage(data.data)
        this.showLoadingMessage = false;
      },
        error => {
          this.showLoadingMessage = false;
          this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
        }
      )
  }

  showSuccessMessage(message) {
    this.displaySuccessMessage = true;
    this.successMessage = message;
    setTimeout(() => {
      this.displaySuccessMessage = false;
    }, 5000);
  }

  openInvoiceBatch() {
    if (!this.enablePrint) return;

    this.showLoadingMessage = true;

    const selectedInvoices = this.invoiceList.filter(item => item.selected
      && item.invoiceReviewStatusId === 3
      && item.invoiceSageStatusId >= 3
      && item.total > 0);

    const invoiceList = selectedInvoices.length > 0
      ? selectedInvoices
      : this.invoiceList.filter(item => item.invoiceReviewStatusId === 3
        && item.invoiceSageStatusId >= 3 && item.total > 0);

    let invoiceIds = invoiceList.map(item => item.id);

    this.reportService.getInvoiceBatch(invoiceIds)
      .pipe(
        timeout(6000000) 
      )
      .subscribe(blob => {
      const fileUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileUrl;
      const now = new Date();
      const formattedDate = now.getFullYear() + 
        String(now.getMonth() + 1).padStart(2, '0') + 
        String(now.getDate()).padStart(2, '0') + 
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getMilliseconds()).padStart(2, '0');

      a.download = `InvoicesBatch_${formattedDate}.pdf`;
      a.click();
      window.URL.revokeObjectURL(fileUrl);
      this.showLoadingMessage = false;
    },
      error => {
        this.showLoadingMessage = false;
        this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
      }
    )
  }

  setUpConfirmAction(status: number, deleteModalStatusId: number) {
    this.deleteModalStatusId = deleteModalStatusId;
    this.confirmAction = async function (that) {
      that.applyReviewStatusToInvoice(status);
      that.closebutton.nativeElement.click();
    };
  }

  checkForInvoiceStatus(invoice): boolean {
    const VALID_INVOICE_REVIEW_STATUS = [3, 4, 5];
    return invoice && invoice.invoiceReviewStatusId === 3 && VALID_INVOICE_REVIEW_STATUS.indexOf(invoice.invoiceSageStatusId) >= 0;
  }

  //setUpConfirmSendUpdateSageToAllAction() {
  //  this.deleteModalStatusId = 6;
  //  this.confirmAction = function (that) {
  //    that.onSendUpdateAllToSage();
  //    that.closebutton.nativeElement.click();
  //  };
  //}

  applyConfirmAction() {
    if (this.confirmAction) {
      const that = this;
      this.confirmAction(that);      
      this.confirmAction = null;
    }
  }

  selectFilter(filterLabel: string) {
    this.btnFilterSelected = filterLabel;
    const filter = this.filters.find(f => f.label === filterLabel);
    if (filter) filter.action();
  }

  updateInvoices() {
    this.showLoadingMessage = true;
    const pharmacyId = this.sharedService.pharmacyId;
    const facilityId = this.sharedService.facilityId;
    const billingDate = this.billingDateFormated;

    this.successMessage = 'Syncing invoices with Kroll...';
    this.displaySuccessMessage = true;

    this.invoiceService.getNewInvoicesByFacilityWithKroll(pharmacyId, facilityId, billingDate).subscribe(data => {
      if (!data.success) {
        this.displaySuccessMessage = false;
        this.showLoadingMessage = false;
        this.loadErrorMessage(data.data);
        return;
      }
      this.invoices = data.data;
      this.invoiceCacheService.setInvoices(JSON.parse(JSON.stringify(this.invoices)));
      this.invoiceList = this.invoices;
      this.displaySuccessMessage = false;
      this.showLoadingMessage = false;
    });
  }

  onFilterAll() {
    this.resetSearchField();
    this.invoiceList = this.invoices;
  }
  onFilterPending() {
    this.resetSearchField();
    this.invoiceList = this.invoices.filter(item => item.invoiceReviewStatusId === 1);
  }
  onFilterFlagged() {
    this.resetSearchField();
    this.invoiceList = this.invoices.filter(item => item.invoiceReviewStatusId === 2);
  }
  onFilterApproved() {
    this.resetSearchField();
    this.invoiceList = this.invoices.filter(item => item.invoiceReviewStatusId === 3);
  }
  onFilterSentByEmail() {
    this.resetSearchField();
    this.invoiceList = this.invoices.filter(item => item.invoiceSageStatusId >= 3 && item.sentByEmail);
  }

  async onSetInvoiceStatus(invoice, status: number, deleteModalStatusId: number) {
    if (invoice.invoiceReviewStatusId == 3) {
      this.closebutton.nativeElement.click();
      return;
    }

    this.deleteModalStatusId = deleteModalStatusId;
    this.patientName = invoice.billedTo;
    this.confirmAction = async function (that) {
      that.closebutton.nativeElement.click();
      that.patientName = '';
      that.showLoadingMessage = true;
      await that.updateInvoice(invoice, status);
      that.showLoadingMessage = false;
    };
    
  }

  //async onConfirmSendInvoiceToSage(invoice, deleteModalStatusId: number) {
  //  this.deleteModalStatusId = deleteModalStatusId;
  //  this.patientName = invoice.billedTo;

  //  this.confirmAction = async function (that) {
  //    that.closebutton.nativeElement.click();
  //    that.patientName = '';
  //    that.showLoadingMessage = true;
  //    await that.onSendUpdateSage(invoice);
  //    that.showLoadingMessage = false;
  //  };
  //}

  async onSendUpdateSage(invoice) : Promise<void> {
    try {
      var result = await this.invoiceService.sendUpdateSage(invoice.id, this.sharedService.getUserId());

      if (!result.success) {
        this.loadErrorMessage(result.data);
        return Promise.resolve();
      }

      const targetIndex = this.invoices.findIndex(i =>
        i.id === invoice.id
        && i.pharmacyId === invoice.pharmacyId
        && i.facilityId === invoice.facilityId
        && i.patientId === invoice.patientId
      );

      if (targetIndex !== -1) {
        this.invoices[targetIndex] = result.data;
        this.invoiceCacheService.setInvoices(JSON.parse(JSON.stringify(this.invoices)));
        this.selectFilter(this.btnFilterSelected);
      }
      
    } catch (e) {
      console.error('Error sending invoice to Sage:', e);
      this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
      Promise.reject();
    }

    return Promise.resolve();
  }

  checkInvoiceStatus(invoice) :boolean {
    return invoice.invoiceSageStatusId === 2 || invoice.invoiceReviewStatusId !== 3;
  }

  resetSearchField() {
    this.searchResident = '';
  }

  resetBtnFilter() {
    this.btnFilterSelected = 'ALL';
  }

  onSearchChange(residentName: string) {
    this.resetBtnFilter();
    this.invoiceList = this.invoices.filter(item => item.billedTo.indexOf(residentName) >= 0);
  }

  selectAll(isSelected) {
    this.invoiceList.forEach(item => { item.selected = isSelected });
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  loadDate() {
    // Use a single `now` to avoid date inconsistencies from multiple `new Date()` calls.
    // Previous month start; no need to adjust year—Date auto-normalizes when month goes below 0.
    const now = new Date();
    this.billableMonthAndYear = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = moment(this.billableMonthAndYear);
    ctrlValue.year(normalizedYear.year());
    this.billableMonthAndYear = ctrlValue.toDate();
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = moment(this.billableMonthAndYear);
    ctrlValue.month(normalizedMonth.month());
    this.billableMonthAndYear = ctrlValue.toDate();
    datepicker.close();
  }

  chosenYearMonthFilter = (d: Date | null): boolean => {
    if (!d) return false;
    const today = new Date();
    const date = new Date(d);
    return date <= today;
  }

  filterNonApprovedInvoices(): any[] {    
    let pendingInvoices = this.invoices.filter(item => item.selected && item.invoiceReviewStatusId != 3);

    if (pendingInvoices.length === 0) {
      pendingInvoices = this.invoices.filter(item => item.invoiceReviewStatusId != 3);
    }

    return pendingInvoices;
  }

  async applyReviewStatusToInvoice(status: number): Promise<void> {
    const selectedInvoices = this.invoiceList.filter(item => item.selected && item.invoiceReviewStatusId !== 3);
    const pendingInvoices = selectedInvoices.length > 0
      ? selectedInvoices
      : this.invoiceList.filter(item => item.invoiceReviewStatusId !== 3);

    this.showLoadingMessage = true;
    for (const invoice of pendingInvoices) {
      await this.updateInvoice(invoice, status);
    }
    this.showLoadingMessage = false;
    return Promise.resolve();
  }

  async updateInvoice(invoice, status): Promise<void> {
    this.showLoadingMessage = true;
    const invoiceWithNewStatus = { ...invoice, invoiceReviewStatusId: status };

    try {
      var result = await this.invoiceService.saveNewInvoice(invoiceWithNewStatus, this.sharedService.getUserId());
      
      if (!result.success) {
        this.loadErrorMessage(result.data);
        return Promise.reject();
      }

      const targetIndex = this.invoices.findIndex(i =>
        i.id === invoiceWithNewStatus.id
        && i.pharmacyId === invoiceWithNewStatus.pharmacyId
        && i.facilityId === invoiceWithNewStatus.facilityId
        && i.patientId === invoiceWithNewStatus.patientId
      );

      const updatedInvoice = result.data;
      if (targetIndex !== -1) {
        this.invoices[targetIndex] = { ...invoiceWithNewStatus, id: updatedInvoice.id };
      }

      this.invoiceCacheService.setInvoices(JSON.parse(JSON.stringify(this.invoices)));

      this.selectFilter(this.btnFilterSelected);
      
    } catch (e) {
      this.setDefaultErrorHandler(e);
      return Promise.reject(e);
    }

    return Promise.resolve();
  }


  async onSendUpdateAllToSage(): Promise<void> {
    const selectedInvoices = this.invoiceList.filter(item => item.selected && item.invoiceReviewStatusId === 3 && item.invoiceSageStatusId === 1);
    const pendingInvoices = selectedInvoices.length > 0
      ? selectedInvoices
      : this.invoiceList.filter(item => item.invoiceReviewStatusId === 3 && item.invoiceSageStatusId === 1);

    this.showLoadingMessage = true;
    for (const invoice of pendingInvoices) {
      await this.onSendUpdateSage(invoice);
    }
    this.showLoadingMessage = false;
    return Promise.resolve();
  }

  onBulkEmailToResidents() {
    console.log('sent bulk email');
  }

  view(invoice) {
    const invoiceId = isNaN(invoice.id) ? 0 : invoice.id;
    this.router.navigate([`invoice/review-detail/${invoiceId}/${invoice.pharmacyId}/${invoice.facilityId}/${invoice.patientId}/${this.billingDateFormated}`]);
  }

  setDefaultErrorHandler(e) {
    console.error('Error: ', e);
    this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
  }
}
